import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import MetaData from '@aok/meta'
import { HeadlineLevel } from '@aok/text-elements'

import Comment from '../../atoms/Comment/Comment'
import CookieBanner from '../../organisms/CookieBanner/CookieBanner'
import MagazineHeader from '../../organisms/MagazineHeader/MagazineHeader'
import MagazineFooter from '../../organisms/MagazineFooter/MagazineFooter'
import Y008 from '../../organisms/M.Y008/Y008'
import Y009 from '../../organisms/M.Y009/Y009'
import Y007 from '../../organisms/M.Y007/Y007'
import Survey from '../../molecules/Survey/Survey'
import Spacer from '../Spacer'
import TeaserListPageLink from '../../molecules/TeaserListPageLink/TeaserListPageLink'
import PageHeader from '../../organisms/PageHeader/PageHeader'

import CombinedContextProvider from '../../../context/CombinedContextProvider'
import {
  footerPropTypes,
  headerPropTypes,
  metaPropTypes,
  pageHeaderPropTypes,
  privacyPropTypes,
  teaserListPagePropTypes,
} from '../../../utils/commonPropTypes'
import { PageType } from '../../../utils/defaultTypes'
import Y018 from '../../organisms/M.Y018/Y018'
import T001 from "../../organisms/M.T001/T001";

const StructureLayout = ({
  children,
  pageType,
  apis,
  meta,
  header,
  pageHeader,
  teaserListPage,
  footer,
  privacy,
  y009,
  y007,
  y008,
  y018,
  surveyEnabled,
  hideHeaderShadow,
  pageHeaderTheme,
  clientList,
}) => {
  const headerRef = useRef(null)

  return (
    <CombinedContextProvider apis={apis} privacy={privacy} clientList={clientList}>
      <MetaData {...meta} pageType={pageType} />

      <CookieBanner />

      <T001 />

      {/* {surveyEnabled && <Survey />} */}

      <MagazineHeader {...header} headerRef={headerRef} hideHeaderShadow={hideHeaderShadow} />

      <main
        id="main-content"
        className="structure
            flex-grow flex-shrink-0
            bg-ffffff
            pt-64 600:pt-80 1280:pt-96
          "
      >
        {pageHeader && <PageHeader {...pageHeader} theme={pageHeaderTheme} />}

        <HeadlineLevel>{children}</HeadlineLevel>
      </main>

      {teaserListPage?.link && (
        <HeadlineLevel>
          <Spacer className="h-48 720:h-80" />
          <TeaserListPageLink {...teaserListPage.link} />
        </HeadlineLevel>
      )}

      {y009 && (
        <HeadlineLevel>
          <Spacer className="h-64 720:h-80 1000:h-112" />
          <Y009 {...y009} />
        </HeadlineLevel>
      )}

      {y018 && (
        <HeadlineLevel>
          <Spacer className="h-64 720:h-80 1000:h-112" />
          <Y018 {...y018} />
        </HeadlineLevel>
      )}

      {y007 && (
        <HeadlineLevel>
          <Spacer className="h-64 720:h-80 1000:h-112" />
          <Y007 {...y007} />
        </HeadlineLevel>
      )}

      <Comment text="googleoff: all" />

      {y008 && (
        <HeadlineLevel>
          {y007?.settings.variant !== 'small' && <Spacer className="h-64 720:h-80 1000:h-112" />}
          <Y008 openDropdown={pageType === PageType.START} {...y008} />
        </HeadlineLevel>
      )}

      <Comment text="googleon: all" />

      <MagazineFooter {...footer} />
    </CombinedContextProvider>
  )
}

StructureLayout.propTypes = {
  children: PropTypes.node,
  pageType: PropTypes.oneOf(Object.values(PageType)),
  apis: PropTypes.object,
  meta: PropTypes.shape(metaPropTypes),
  header: PropTypes.shape(headerPropTypes),
  footer: PropTypes.shape(footerPropTypes),
  privacy: PropTypes.shape(privacyPropTypes),
  pageHeader: PropTypes.shape(pageHeaderPropTypes),
  teaserListPage: PropTypes.shape(teaserListPagePropTypes),
  y008: PropTypes.object,
  y009: PropTypes.object,
  y007: PropTypes.object,
  y018: PropTypes.object,
  surveyEnabled: PropTypes.bool,
  hideHeaderShadow: PropTypes.bool,
}

export default StructureLayout
